module.exports = __webpack_public_path__ + "img/12.71d07b59.jpg";